<div class="container-fluid">
  <div class="row justify-content-between">
    <div class="col-xl-6 px-0">
      <div class="mt-0 mt-md-4 widget-wrapper">
        <div class="widget-header">
          <div class="px-3">
            <h2 class="mr-0">
              <info-tooltip2 class="mx-2" titleName="Audience Engagement"
                tooltipValue="Shows user engagement data for mobile over the past 30 days."
                color="white"></info-tooltip2>
              <img class="beta-tag" src="/assets/images/beta-tag.png" alt="Beta Tag" />
            </h2>
            <app-new-tag class="mr-auto mr-lg-0 ml-lg-auto my-auto"></app-new-tag>
            <div class="mt-2">
              <ng-container *ngTemplateOutlet="swiperControls"></ng-container>
            </div>
          </div>
        </div>
        <div class="widget-body p-0">
          <div class="px-3">
            <app-user-engagement [data]="data"></app-user-engagement>
          </div>
        </div>
      </div>
      <div class="mt-4 widget-wrapper">
        <div class="widget-header">
          <div class="px-3">
            <h2>
              <info-tooltip2 class="mx-2" titleName="Ad Performance"
                tooltipValue="How ads performed on mobile over the last 30 days." color="white"></info-tooltip2>
              <img class="beta-tag" src="/assets/images/beta-tag.png" alt="Beta Tag" />
            </h2>
            <app-new-tag class="ml-auto my-auto"></app-new-tag>
          </div>
        </div>
        <div class="row widget-body p-0">
          <div class="col-lg-12">
            <app-ad-performance [data]="data"></app-ad-performance>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-6 mt-4 widget-wrapper">
      <div class="row widget-header">
        <div class="col-lg-12">
          <h2>
            <info-tooltip2 class="mx-2" titleName="Device Distribution"
              tooltipValue="Share of mobile traffic by device type in the last 30 days." color="white"></info-tooltip2>
          </h2>
          <app-new-tag class="ml-auto my-auto"></app-new-tag>
        </div>
      </div>
      <div class="row widget-body p-0">
        <div class="col-lg-12">
          <app-contribution-platform [data]="data"></app-contribution-platform>
        </div>
      </div>
    </div>
  </div>
</div>